import { LiveAnnouncerController } from '@components/live_announcer/live_announcer.controller';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import type { Config } from '@services/config.service';
import type { UnitNode } from '@services/unit.service';
import { useService } from '@visiba/instantiation';
import { useLayoutEffect } from 'react';
import { useCurrentLocation } from './use_current_location';

export function useTitle(title: string): void {
	const liveAnnouncerController = useService(LiveAnnouncerController);
	const [unit, config] = useCurrentLocation();

	useLayoutEffect(
		function whenHookMounts() {
			return __TEMP__setTitle(title, config, unit, liveAnnouncerController);
		},
		[liveAnnouncerController, title, config, unit],
	);
}

// This is for the Angular web. 🙃👍
export function __TEMP__setTitle(
	title: string,
	config: Config | null,
	unit: UnitNode | null,
	liveAnnouncerController: LiveAnnouncerController,
): () => void {
	const prevTitle = document.title;
	document.title = (config?.licenceHolderMetaData.displayName ?? unit?.name ?? '') + ' - ' + title;

	const removeMessage = liveAnnouncerController.announce(
		withTranslation('Common.Word.A11y.NavigateTo', {
			location: title,
		}),
	);

	return () => {
		removeMessage();
		document.title = prevTitle;
	};
}
